import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { LoggedInUserService } from './services/loggedin-user.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HomeAuthGuard implements  CanActivate {
  constructor (private loggedInUser: LoggedInUserService, private router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (!this.loggedInUser.accessToken) {
        this.router.navigate(['login']);
        return false;
      }
    return true;
  }
}
